import { Box, Divider, Grid, Typography } from "@mui/material";
import styles from './Pendencies.module.css';
import { Pendencie } from "../../assets/icons/pendencie";
import { PendenciesList } from "./PendenciesList";
import { useTranslation } from "react-i18next";
import { KeyDrivePageContainer } from "../../components/KeydriveComponents/PageContainer/KeyDrivePageContainer";

export const Pendencies = () => {

    const {t} = useTranslation();

    return (
        <KeyDrivePageContainer icon={<Pendencie color="#22638D" colorCircle="#22638D"/>} title={t("Pendencias.message")} subtitle={t("Pendencias.text")} divider>
            <PendenciesList/>
        </KeyDrivePageContainer>
    )
}